var _style, _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZotLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114.1,
    height: 45,
    viewBox: "0 0 114.1 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#FFFFFF;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m35.8 30.4c6 1.1 10.4 2.4 10.4 5.6 0 6.1-11.9 9-23.1 9s-23.1-3.2-23.1-9c0-5.2 11.9-6.6 23.1-6.6h0.1s-3.1 1.1-6 2.1c-2.5 0.9-7.9 1.9-9.2 2.3-4.4 1.1-5.3 2.4-5.3 2.6 0 0.3 1 1.5 5.3 2.6 4 1 9.3 1.6 15 1.6s11-0.6 15-1.6c4.4-1.1 5.3-2.4 5.3-2.6 0-0.3-1-1.5-5.3-2.6-1.4-0.4-3-0.7-4.8-0.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m23.2 15.8c-11.1 0-23.1-2.7-23.1-7.7 0-5.4 11.9-8.1 23.1-8.1s23.1 2.8 23.1 8.1c0 5-12 7.7-23.1 7.7zm0-11.7c-5.7 0-11 0.5-15 1.5-4.4 1.1-5.3 2.2-5.3 2.5 0 0.2 1 1.4 5.3 2.5 4 1 9.3 1.5 15 1.5s11-0.5 15-1.5c4.4-1.1 5.3-2.2 5.3-2.5 0-0.2-1-1.4-5.3-2.5-4-0.9-9.3-1.5-15-1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m42.8 20.7c-15.7 18.4-25.5 20.5-27.7 20.5-0.1 0-11.9-2.6-11.9-2.6l-0.4-2.3c9.4-1 26.6-3.7 40-15.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m26.1 28.3c3.3-1.5 11.8-10.2 10.9-15.4l9.3-4.8c0 12.4-17.5 18.7-20.2 20.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-22.2,-15.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m97.2 33.4-13.1 14.7h13.1v3.5h-17.9v-3.9l13.1-14.7h-12.5v-3.4h17.2v3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m100.1 40.6c0-4 1.2-7.1 3.6-9.1 1.9-1.7 4.3-2.5 7.3-2.5 3.4 0 6.1 1.1 8 3.3 1.9 2 2.8 4.8 2.8 8.4 0 4-1.2 7-3.5 9.1-1.9 1.7-4.4 2.5-7.4 2.5-3.4 0-6.1-1.1-8.1-3.4-1.7-2.1-2.7-4.9-2.7-8.3zm4.3 0c0 2.8 0.7 5 2.2 6.5 1.2 1.2 2.7 1.9 4.5 1.9 2.1 0 3.8-0.8 5-2.4 1.1-1.5 1.6-3.4 1.6-5.9 0-2.9-0.7-5.1-2.1-6.5-1.2-1.2-2.7-1.8-4.5-1.8-2.1 0-3.8 0.8-5 2.4-1.2 1.3-1.7 3.3-1.7 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m136.3 48.3v3.5c-1 0.3-2 0.4-3 0.4-2 0-3.6-0.6-4.6-1.9-0.9-1-1.3-2.4-1.3-4.2v-13.1h-3.3v-3.5h3.3l0.3-5.3h3.8v5.3h4.7v3.5h-4.7v13.2c0 1.6 0.8 2.5 2.3 2.5 0.8-0.1 1.6-0.2 2.5-0.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZotLogoWhite);
export default __webpack_public_path__ + "static/media/zotLogoWhite.e254d8529e58246e6068e5633f20c082.svg";
export { ForwardRef as ReactComponent };